import styled from "@emotion/styled";

export const Table = styled.table`
    width: 100%;
    border-collapse: collapse;
    background-color: white;
    table-layout: auto; /* 可変幅 */
`;

export const Tr = styled.tr`
    transition: background-color 0.3s;
    &:hover {
        background-color: #f5f5f5;
    }
`;

type Props = {
    isFitContent?: boolean;
};

export const Th = styled("th")<Props>(({isFitContent}) => ({
    padding: "10px",
    textAlign: "left",
    fontWeight: "normal",
    ...(isFitContent && {
        width: "0",
        whiteSpace: "nowrap",
    }),
}));

export const Td = styled("td")<Props>(({isFitContent}) => ({
    padding: "8px 10px",
    textAlign: "left",
    verticalAlign: "middle",
    whiteSpace: "normal", // 折り返し可
    wordBreak: "break-word",

    ...(isFitContent && {
        width: "0",
        whiteSpace: "nowrap",
    }),
    ['&:has(input[type="text"])']: {
        verticalAlign: "top",
    },
    ["&:has(select)"]: {
        verticalAlign: "top",
    },
    ['&[data-column="slug"]']: {
        maxWidth: "160px",
    },
}));

export const TableContainer = styled.div<{isFill?: boolean}>`
    max-width: ${(props) => (props.isFill ? "100%" : "1180px")};
    overflow-x: auto;
`;

export type ColumnDef = {
    label: string;
    width?: number;
    required?: boolean;
};
